
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(111|665)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
